var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { class: { "nav-scroll": _vm.scrolled } },
    [
      _c(
        "div",
        { staticClass: "navbar", class: { transparent: _vm.transparent } },
        [
          _vm.nation
            ? _c(
                "div",
                {
                  attrs: { name: "nation" },
                  on: {
                    click: function($event) {
                      _vm.openedSetSiteInfo = true
                    }
                  }
                },
                [
                  _vm.siteCode == _vm.$config.SITECODE_OGAUC
                    ? _c("div", { staticClass: "nation" }, [
                        _c("i", { staticClass: "icon icon-nation-nz" }),
                        _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s(/*오클랜드*/ _vm.$t("ogauc_국가명")))
                        ])
                      ])
                    : _vm._e(),
                  _vm.siteCode == _vm.$config.SITECODE_OGHCM
                    ? _c("div", { staticClass: "nation" }, [
                        _c("i", { staticClass: "icon icon-nation-vn" }),
                        _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s(/*베트남*/ _vm.$t("ogvtn_국가명")))
                        ])
                      ])
                    : _vm._e(),
                  _vm.siteCode == _vm.$config.SITECODE_OGIND
                    ? _c("div", { staticClass: "nation" }, [
                        _c("i", { staticClass: "icon icon-nation-ind" }),
                        _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s(/*인도*/ _vm.$t("ogind_국가명")))
                        ])
                      ])
                    : _vm._e(),
                  _vm.siteCode == _vm.$config.SITECODE_OGMMR
                    ? _c("div", { staticClass: "nation" }, [
                        _c("i", { staticClass: "icon icon-nation-mm" }),
                        _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s(/*미얀마*/ _vm.$t("ogmmr_국가명")))
                        ])
                      ])
                    : _vm._e(),
                  _vm.siteCode == _vm.$config.SITECODE_OGCBD
                    ? _c("div", { staticClass: "nation" }, [
                        _c("i", { staticClass: "icon icon-nation-cam" }),
                        _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s(/*캄보디아*/ _vm.$t("ogcbd_국가명")))
                        ])
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm.isPersonalUser
            ? [
                _vm.goback &&
                _vm.isUserPwdRegiYn != "1" &&
                _vm.isUserPwdRegiYn != "2" &&
                _vm.isUserPwdRegiYn != "4" &&
                (!_vm.isLvbdInfoRegiMandanCustYn ||
                  (_vm.isLvbdInfoRegiMandanCustYn && _vm.isLvbdInfoRegiYn)) &&
                this.sessionInfo.userInfo.mchtlModfiYn != "1"
                  ? _c("i", {
                      staticClass: "icon icon-goback",
                      on: { click: _vm.actGoBackPage }
                    })
                  : _vm._e()
              ]
            : [
                _vm.goback &&
                _vm.isUserPwdRegiYn != "1" &&
                _vm.isUserPwdRegiYn != "2" &&
                _vm.isUserPwdRegiYn != "4"
                  ? _c("i", {
                      staticClass: "icon icon-goback",
                      on: { click: _vm.actGoBackPage }
                    })
                  : _vm._e()
              ],
          _vm.getServer()
            ? _c(
                "router-link",
                {
                  staticStyle: {
                    "text-align": "center",
                    display: "inline-block",
                    width: "50%",
                    "background-color": "red",
                    "font-weight": "bold"
                  },
                  attrs: { to: { name: "motpTest" }, tag: "span" }
                },
                [
                  _vm._v(" [ "),
                  "development|local".includes(this.server)
                    ? [_vm._v(_vm._s(_vm.server))]
                    : [_vm._v("staging")],
                  _vm._v(" ] ")
                ],
                2
              )
            : _vm._e(),
          _vm.isPersonalUser
            ? [
                _vm.menu &&
                _vm.isUserPwdRegiYn != "1" &&
                _vm.isUserPwdRegiYn != "2" &&
                _vm.isUserPwdRegiYn != "4" &&
                _vm.siteCode != _vm.$config.SITECODE_OGCBD &&
                (!_vm.isLvbdInfoRegiMandanCustYn ||
                  (_vm.isLvbdInfoRegiMandanCustYn && _vm.isLvbdInfoRegiYn)) &&
                this.sessionInfo.userInfo.mchtlModfiYn != "1"
                  ? _c("i", {
                      staticClass: "icon icon-all-menu",
                      on: {
                        click: function($event) {
                          _vm.menuOpen = true
                        }
                      }
                    })
                  : _vm._e()
              ]
            : [
                _vm.menu &&
                _vm.isUserPwdRegiYn != "1" &&
                _vm.isUserPwdRegiYn != "2" &&
                _vm.isUserPwdRegiYn != "4" &&
                _vm.siteCode != _vm.$config.SITECODE_OGCBD
                  ? _c("i", {
                      staticClass: "icon icon-all-menu",
                      on: {
                        click: function($event) {
                          _vm.menuOpen = true
                        }
                      }
                    })
                  : _vm._e()
              ]
        ],
        2
      ),
      _vm.menuOpen ? _c("all-menu") : _vm._e(),
      _c("choose-site-info", {
        attrs: { opened: _vm.openedSetSiteInfo },
        on: {
          "update:opened": function($event) {
            _vm.openedSetSiteInfo = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }